import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { ALIMENTACAO, SINTOMAS } from "./rotinaUtil";

const MAX = 300;

const SectionTitle = ({ children }) => (
  <Typography variant="subtitle2" color="text.secondary" sx={{ textTransform: "uppercase" }}>
    {children}
  </Typography>
);

/** Diálogo com a rotina (alimentação, descanso e saúde) de um aluno no dia. */
const IntegralRotinaForm = ({ integralRotina, onClose, onSave, isSaving }) => {
  const [form, setForm] = useState(null);

  useEffect(() => {
    setForm(integralRotina ? { ...integralRotina } : null);
  }, [integralRotina]);

  const set = (campo, valor) => setForm((prevState) => ({ ...prevState, [campo]: valor }));
  const podeSalvar = form?.lanche && form?.almoco && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!podeSalvar) return;
    onSave(form);
  };

  const selectAlimentacao = (campo, label) => (
    <TextField
      select
      size="small"
      fullWidth
      required
      label={label}
      value={form[campo] ?? ""}
      onChange={(event) => set(campo, event.target.value)}
    >
      {ALIMENTACAO.map((a) => (
        <MenuItem key={a.value} value={a.value}>
          {a.value}
        </MenuItem>
      ))}
    </TextField>
  );

  return (
    <Dialog open={Boolean(integralRotina)} onClose={onClose} fullWidth maxWidth="sm">
      {form && (
        <form onSubmit={handleSubmit}>
          <DialogTitle>{form.alunoTurma?.aluno?.nome ?? "Rotina"}</DialogTitle>
          <DialogContent>
            <Stack spacing={3} pt={1}>
              <Stack spacing={2}>
                <SectionTitle>Alimentação</SectionTitle>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>{selectAlimentacao("lanche", "Lanche")}</Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>{selectAlimentacao("almoco", "Almoço")}</Grid>
                </Grid>
                <TextField
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  label="Observação da alimentação"
                  value={form.observacaoAlimentacao ?? ""}
                  onChange={(event) => set("observacaoAlimentacao", event.target.value)}
                  helperText={`${(form.observacaoAlimentacao ?? "").length}/${MAX}`}
                  slotProps={{ htmlInput: { maxLength: MAX } }}
                />
              </Stack>

              <Divider />

              <Stack spacing={1}>
                <SectionTitle>Sono / Descanso</SectionTitle>
                <FormControlLabel
                  control={
                    <Switch checked={Boolean(form.sonoDescanso)} onChange={(event) => set("sonoDescanso", event.target.checked)} />
                  }
                  label="Dormiu / descansou"
                />
              </Stack>

              <Divider />

              <Stack spacing={1}>
                <SectionTitle>Acompanhamento de saúde</SectionTitle>
                <Box>
                  <Grid container>
                    {SINTOMAS.map(({ campo, label }) => (
                      <Grid key={campo} size={{ xs: 6, sm: 4 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              color="error"
                              checked={Boolean(form[campo])}
                              onChange={(event) => set(campo, event.target.checked)}
                            />
                          }
                          label={label}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
                <TextField
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  label="Observação da saúde"
                  value={form.observacaoSaude ?? ""}
                  onChange={(event) => set("observacaoSaude", event.target.value)}
                  helperText={`${(form.observacaoSaude ?? "").length}/${MAX}`}
                  slotProps={{ htmlInput: { maxLength: MAX } }}
                />
              </Stack>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancelar</Button>
            <Button type="submit" variant="contained" disabled={!podeSalvar}>
              Salvar
            </Button>
          </DialogActions>
        </form>
      )}
    </Dialog>
  );
};

export default IntegralRotinaForm;
